import React, { useContext } from "react";
import "./What_makes.css";
import Common_subHeading from "../../../common_components/common_subHeading/Common_subHeading";
import { IDS } from "../../../../utils/IDS";
import { Context } from "../../../../utils/context";

function What_makes({ data }) {

  const {language} = useContext(Context);

  return (
    <>
      <section className="What_makes">
        <div className="container">
          {/* <Common_subHeading subHeading={`What makes ${data?.name} unique? `} /> */}

          <Common_subHeading subHeading={language == 1 ? "What Makes France Unique?" : "Qu'est-ce qui rend la France unique ?"} />

          <div className="What_makes_cards_holder">
            <div className="row justify-content-center">
              {data?.WebWhatMakeuniques?.length > 0 ? (
                data?.WebWhatMakeuniques?.map((card, index) => (
                  <div className="col-lg-4 col-md-6 col-sm-6" key={index}>
                    <div className="cards_holder">
                      <div className="img_holder">
                        <img
                          src={IDS?.IMG_URL + card.image}
                          alt="unique img"
                          className="unique_img"
                        />
                      </div>
                      <div className="text_holder">
                        <p>{card.WebWhatMakeUnique_Lang?.name}</p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center">No Data Found</div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default What_makes;
